export interface User {
  id: string
  name: string
  personalNumber: string
  rfidChip: string
  isAdmin: boolean
  createdAt: Date
}

export function createUser(
  name: string,
  personalNumber: string,
  rfidChip: string,
  isAdmin: boolean,
): User {
  return {
    id: Math.random().toString(36).substr(2, 9),
    name,
    personalNumber,
    rfidChip,
    isAdmin,
    createdAt: new Date(),
  }
}
